import React, { useState } from 'react';
import isEqual from 'lodash/isEqual';
import { DropMenuReact } from 'common/components/drop-menu';
import styles from 'apps/boards/src/dashboards-app/components/global-filter-bar/index.module.styl';
import { Visibility, VisibilityChangeEvent } from 'common/components/base/stackable';
import { QueryEntrySectionReact } from 'common/query-builder/query-entry-section';
import { IncludeCustomPropertyType } from 'common/query-builder/query-block/properties-menu/types';
import { QuerySegmentEntry, RowLabelType, SelectorTypeDefinitions } from 'common/query-builder/query-entry-section/types';
import { useTranslation } from 'common/i18n/hooks';
import { transformFromQuerySegmentEntries, transformToQuerySegmentEntries } from 'common/query-builder/query-builder/util';
import { Segment } from 'common/query-builder/query-block/segment-menu/types';
export function BreakdownDropMenu(props: {
  breakdown?: Segment;
  onCommit: (breakdown: Segment) => void;
  onClose: () => void;
  projectId: number;
  workspaceId: number;
  userId: number;
  trackName: string;
  onTrack: (ev: CustomEvent) => void;
  positionParent?: HTMLElement;
}) {
  const {
    t
  } = useTranslation();
  const [staged, setStaged] = useState<Segment | null>(props.breakdown || null);
  return <DropMenuReact className={styles.dropMenu} positionParent={props.positionParent} open
  // @ts-ignore -- todo micah: onChange type is conflicting with dom onChange form event, need to fix p2r prop types
  onChange={(ev: VisibilityChangeEvent) => {
    if (ev.detail.state !== Visibility.Open) {
      if (staged && !isEqual(staged, props.breakdown)) {
        props.onCommit(staged);
      }
      props.onClose();
    }
  }} data-sentry-element="DropMenuReact" data-sentry-component="BreakdownDropMenu" data-sentry-source-file="breakdown-menu.tsx">
      <div className={styles.filterContainer}>
        <QueryEntrySectionReact dataGroupsEnabled enableAllDataGroupsForScdProps disableAddEntry projectId={props.projectId} userId={props.userId} workspaceId={props.workspaceId} includeCustomProperties={IncludeCustomPropertyType.All} enableEnhancedListFilters entries={staged ? transformToQuerySegmentEntries([staged]) : []} hideEvents={false} minEntries={1} projectHasPeople projectHasCohorts stagingRow={!staged} rowLabelType={RowLabelType.None} rowDraggable={false} rowTypes={[SelectorTypeDefinitions.Segment]} trackName={props.trackName} sectionTitle={props.breakdown ? t("query-builder.breakdown") : t("query-builder.actions.add-breakdown")} onUpdate={updates => {
        const segment = transformFromQuerySegmentEntries(updates.entries as QuerySegmentEntry[])[0];
        if (segment) {
          setStaged(segment);
        } else {
          props.onClose();
        }
      }} onAbortStage={committing => {
        if (!committing) {
          props.onClose();
        }
      }} onTrack={props.onTrack} data-sentry-element="QueryEntrySectionReact" data-sentry-source-file="breakdown-menu.tsx" />
      </div>
    </DropMenuReact>;
}